module.exports = __webpack_public_path__ + "static/media/Highway-Rider-Extreme.6f54062c.png";